/* 公共自定义列render
* 部分 自定义列 是各个tab共有、都可以展示的，这些列的render写在这里：
* render中的 this，经过 .bind 后，仍指向实例。 */
// import Apis from 'Src/const/apis'
// 推广管理BFF-新接口定义
import ApiUrl from 'Src/const/apis/promotion/index'
import tool from 'Src/util/tool'
import json from 'Src/util/json.js'
import {
  CampaignType,
  PromotionHeaderTips,
  adSelectedType
} from './promotion-state'
import { campaignType } from 'Src/const/state/campaign.js'
import {
  NEG_WORD_GROUP_SINGLE_SET,
  NEG_WORD_PLAN_SINGLE_SET
} from 'Src/pagelets/toolbox/batch-edit/privative-set/const'
import { isNil } from 'Src/util/type'

// const openDelay = 1000
// const hideDelay = 0
export const NoDataStr = '--'

export function getColMinWidth (curWidth, val, charWidth = 12, padding = 0) {
  const newWidth = val.toString().length * charWidth + padding
  if (isNaN(curWidth)) {
    curWidth = 0
  }
  return Math.max(curWidth, newWidth)
}

// 根据当前路由名称和目标路由名称，判断是上钻或下钻，以配置不同的查询参数类型
function getQueryType (curRouteName, targetRouteName) {
  const levelList = ['campaign', 'ad', 'creative']
  const targetRouteLevel = levelList.indexOf(targetRouteName)
  const curRouteLevel = levelList.indexOf(curRouteName)

  return (targetRouteLevel < curRouteLevel)
}

const keywordQualityDataDefault = {
  word: '', // 当前词语
  quality: '', // 总质量度
  qualityMsg: '', // 总质量度文案
  relevanceQuality: null, // 相关性质量度
  ctrQuality: null, // 预估点击率
  isNoData: false,
  fontClass: '',
  chartLine: {
    data: new Array(7).fill(0).map((item, index) => {
      const xIndex = 6 - index
      item = {
        date: dayjs().subtract(xIndex, 'day').format('MM.DD'),
        value: null
      }
      return item
    }),
    legend: {
      show: false
    },
    animate: false,
    padding: [20, 0, 0, 0],
    xAxis: {
      type: 'category',
      tickCount: 7
    },
    yAxis: {
      type: 'value',
      max: 10,
      min: 0,
      tickLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      }
    },
    series: [
      {
        type: 'line',
        name: '质量度',
        encode: {
          x: 'date',
          y: 'value'
        },
        label: {
          show: true
        },
        marker: {
          show: true
        }
      }
    ]
  }
}
export function getKeywordQualityData (context) {
  this.keywordQualityData = json.deepCopy(keywordQualityDataDefault) // 清空以展示loading
  let qualityData = this.keywordQualityData
  const row = tool.safetyGet(context, 'row', {})
  const qualityInfo = tool.safetyGet(context, 'row.stat_data.quality', {})
  this.keywordQualityData.word = tool.safetyGet(context, 'row.word', '')
  qualityInfo.quality = parseInt(qualityInfo.quality)
  if (!isNil(qualityInfo.quality)) {
    if (qualityInfo.quality < 5) {
      qualityData.fontClass = 'quality-low'
    } else if (qualityInfo.quality > 8) {
      qualityData.fontClass = 'quality-high'
    }
  }
  Object.assign(qualityData, {
    quality: qualityInfo.quality || '-',
    qualityMsg: qualityInfo.quality_msg
  })
  if (isNil(qualityInfo.relevance_quality) || isNil(qualityInfo.ctr_quality)) {
    qualityData.isNoData = true
    return
  }

  Object.assign(qualityData, {
    relevanceQuality: tool.safetyGet(qualityInfo, 'relevance_quality', 0) / 2, // 相关性质量度
    ctrQuality: tool.safetyGet(qualityInfo, 'ctr_quality', 0) / 2
  })
  // 关键词列表刷新前，已经请求过的趋势图数据，直接取，减少后端请求次数
  if (this.keywordQualityList[row.ad_bidword_id]) {
    this.keywordQualityData.chartLine.data = qualityData.chartLine.data.map((item, index) => {
      Object.assign(item, {
        value: this.keywordQualityList[row.ad_bidword_id][index]
      })
      return item
    })
    return
  }

  BUI.update({
    type: 'POST',
    url: ApiUrl.promote.keyword.qualityTrend,
    data: JSON.stringify({
      st: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
      et: dayjs().subtract(0, 'day').format('YYYY-MM-DD'),
      fields: ['quality'],
      ad_id: row.ad_id + '',
      ad_bidword_id: row.ad_bidword_id + ''
    }),
    contentType: 'application/json',
    success: resp => {
      if (resp && resp.code === 0) {
        this.keywordQualityData.chartLine.data = qualityData.chartLine.data.map((item, index) => {
          Object.assign(item, {
            value: resp.data.quality_trend[index]
          })
          return item
        })
        this.keywordQualityList[row.ad_bidword_id] = resp.data.quality_trend
      }
    }
  })
}

export const preventOverflowOptions = {
  modifiers: {
    gpuAcceleration: false,
    flip: {
      behavior: ['left', 'right', 'top', 'bottom'],
      boundariesElement: 'viewport'
    },
    preventOverflow: {
      enable: false,
      boundariesElement: 'viewport'
    }
  }
}

export const preventOverflowUpDownOptions = {
  modifiers: {
    gpuAcceleration: false,
    flip: {
      behavior: ['bottom', 'top'],
      boundariesElement: 'viewport'
    },
    preventOverflow: {
      enable: false,
      boundariesElement: 'viewport'
    }
  }
}

export const adaptivePositionOptions = {
  modifiers: {
    gpuAcceleration: false,
    flip: {
      behavior: 'flip',
      boundariesElement: 'viewport'
    },
    preventOverflow: {
      enable: false,
      boundariesElement: 'viewport'
    }
  }
}

export const PublicRenders = {
  publicRenderCampaignName (h, context) {
    const value = context.row['campaign_name']

    const isGoUpForGlobalFilter = getQueryType(this.$route.name, 'campaign')

    return <div class='ad-link pointer multiple-line-txt-cut'
      title={value}
      onClick={this.onClickCampaignName.bind(this, context, isGoUpForGlobalFilter)}>
      {value}
    </div>
  },
  publicRenderCampaignType (h, context) {
    const value = context.row['campaign_type']
    // 先取后端的，没有取前端的
    return <div class='multiple-line-txt-cut'>{context.row['campaign_type_name'] || CampaignType[value]}</div>
  },

  publicRenderAdName (h, context) {
    const value = context.row['ad_name'] || context.row['name']

    if (!value) {
      return NoDataStr
    }

    const isGoUpForGlobalFilter = getQueryType(this.$route.name, 'ad')

    return <div class='ad-link pointer multiple-line-txt-cut'
      title={value}
      onClick={this.onClickAdName.bind(this, context, isGoUpForGlobalFilter)}>
      { value }
    </div>
  },
  publicRenderAdTime (h, context) {
    const ad = context.row
    let startDate = ad.start_time
    let endDate = ad.end_time
    let dateStr = NoDataStr

    if (startDate && endDate) {
      startDate = startDate.split(' ')[0] // 精确到天即可
      endDate = endDate.split(' ')[0]
      dateStr = `${startDate} ${$bp_t('至', 'common.to')} ${endDate}`
    }
    return <div class='multiple-line-txt-cut'>{dateStr}</div>
  },
  publicRenderName (h, context) {
    const key = context.column.key + '_name'
    const val = context.row[key] || NoDataStr

    return <div class='multiple-line-txt-cut'>{val}</div>
  },

  publicRenderAppCodeName (h, context) {
    const key = context.column.key
    const typesArr = context.row[key] || []
    // 解决获取到的typesArr不是数组的问题
    const value = Array.isArray(typesArr) ? typesArr.join(',') : typesArr

    return <div title={value} class='multiple-line-txt-cut pointer'>{value || NoDataStr}</div>
  },
  publicRenderLink (h, context) {
    const key = context.column.key
    const val = context.row[key]

    return val && val.indexOf('--') === -1 ? <a class='cell-content-link txt-cut'
      target='_blank'
      title={val}
      href={this.globalUpdateQuery(val)}>{val}</a> : <div class='multiple-line-txt-cut'>{NoDataStr}</div>
  },
  publicRenderEllipsisText (h, context) {
    const key = context.column.key
    const value = context.row[key]

    return <div class='multiple-line-txt-cut' title={value}>{value || NoDataStr}</div>
  },
  publicRenderCampaignDenyWord (h, context) {
    const row = context.row
    const isSearchCampaign = row.campaign_type === campaignType.SEARCH_AD.value
    const flag = !row.set_privative ? <a href='javascript:void(0)' onClick={this.onPrivativeSetClick.bind(this, NEG_WORD_GROUP_SINGLE_SET, [row])}>{$bp_t('未设置', 'common.not_set')}</a>
      : <span><a style='display:block;' href='javascript:void(0)' onClick={this.onPrivativeSetClick.bind(this, NEG_WORD_GROUP_SINGLE_SET, [row])}>{ $bp_t('短语否定词：', 'bp.promotion_campaign_short_pharse_word') + row.phrase_words_cnt}</a>
        <a style='display:block;' href='javascript:void(0)' onClick={this.onPrivativeSetClick.bind(this, NEG_WORD_GROUP_SINGLE_SET, [row])}>{ $bp_t('精确否定词：', 'bp.promotion_campaign_accurate_pharse_word') + row.precise_words_cnt}</a></span>
    return (
      isSearchCampaign ? flag : <span>--</span>
    )
  },
  publicRenderAdDenyWord (h, context) {
    const row = context.row
    const isSearchCampaign = row.campaign_type === campaignType.SEARCH_AD.value && row.delivery_mode === 1
    const flag = row.privative_source ? <span>
      <a style='display:block;' href='javascript:void(0)' onClick={this.onPrivativeSetClick.bind(this, NEG_WORD_PLAN_SINGLE_SET, [row])}>{ $bp_t('短语否定词：', 'bp.promotion_campaign_short_pharse_word') + row.ad_phrase_words_cnt}</a>
      <a style='display:block;' href='javascript:void(0)' onClick={this.onPrivativeSetClick.bind(this, NEG_WORD_PLAN_SINGLE_SET, [row])}>{ $bp_t('精确否定词：', 'bp.promotion_campaign_accurate_pharse_word') + row.ad_precise_words_cnt}</a>
    </span> : <a href='javascript:void(0)' onClick={this.onPrivativeSetClick.bind(this, NEG_WORD_PLAN_SINGLE_SET, [row])}>{ $bp_t('未设置', 'common.not_set') }</a>
    return (
      isSearchCampaign ? flag : <span>--</span>
    )
  },
  publicRenderGuiyin (h, context) {
    const key = context.column.key
    let value = context.row[key] || context.row.stat_data[key]

    if (value) {
      if (context.column.unit && context.column.unit !== '元') {
        value += context.column.unit
      }
    }

    const noData = (!value && value !== 0 && value !== '0')

    return <div class='default-col multiple-line-txt-cut'>
      <div>{noData ? NoDataStr : value }</div>
      <div style="color:#999;">{context.column.guiyinType}天</div>
    </div>
  }
}

export const defaultColRender = function (h, context) {
  const key = context.column.key
  let value = context.row[key] || context.row.stat_data[key]

  if (value) {
    if (context.column.unit && context.column.unit !== '元') {
      value += context.column.unit
    }
  }

  const noData = (!value && value !== 0 && value !== '0')

  return <div class='default-col multiple-line-txt-cut'>{noData ? NoDataStr : value }</div>
}

export const defaultPopoverHeaderRender = function (h, context) {
  let popoverContent = context.row.desc || PromotionHeaderTips[context.row.key]
  // let showPopoverContent = !!popoverContent

  const title = context.row.title
  const colSortable = context.column.sortable

  const tableHeaderClass = ['table-header', 'multiple-line-txt-cut']
  const sortable = (colSortable === undefined) ? true : colSortable // 没有配置sort，默认为true
  if (sortable) {
    tableHeaderClass.push('th-sortable')
  }

  return <div class='default-header-wrapper' onMouseenter={(event) => { if (popoverContent) this.handleMouseEnterHeader(event, popoverContent, context) }}>
    <div
      class={tableHeaderClass}>
      {title}
    </div>
  </div>
}

export const shortTermFieldHeaderRender = function (h, context) {
  let popoverContent = context.row.desc || PromotionHeaderTips[context.row.key]
  // let showPopoverContent = !!popoverContent

  const title = context.row.title
  const colSortable = context.column.sortable

  const tableHeaderClass = ['table-header', 'single-line-txt-cut']
  const sortable = (colSortable === undefined) ? true : colSortable // 没有配置sort，默认为true
  if (sortable) {
    tableHeaderClass.push('th-sortable')
  }

  return <div class='default-header-wrapper' onMouseenter={(event) => { if (popoverContent) this.handleMouseEnterHeader(event, popoverContent, context) }}>
    <div
      class={tableHeaderClass}>
      {title}
    </div>
    <div
      class={tableHeaderClass}>
      即时影响
    </div>
  </div>
}

export const longTermFieldHeaderRender = function (h, context) {
  let popoverContent = context.row.desc || PromotionHeaderTips[context.row.key]
  // let showPopoverContent = !!popoverContent

  const title = context.row.title
  const colSortable = context.column.sortable

  const tableHeaderClass = ['table-header', 'single-line-txt-cut']
  const sortable = (colSortable === undefined) ? true : colSortable // 没有配置sort，默认为true
  if (sortable) {
    tableHeaderClass.push('th-sortable')
  }

  return <div class='default-header-wrapper' onMouseenter={(event) => { if (popoverContent) this.handleMouseEnterHeader(event, popoverContent, context) }}>
    <div
      class={tableHeaderClass}>
      {title}
    </div>
    <div
      class={tableHeaderClass}>
      长期影响
    </div>
  </div>
}

export const checkboxHeaderRender = function (h, context) {
  const activeCurrentPage = this.currentSelectedWay === adSelectedType.currentPage
  const activeAllPage = this.currentSelectedWay === adSelectedType.allPage
  return <div>
    <byted-checkbox
      vModel={this.checkboxSelected}
      data-test="promotionAdSelectAll"
      onChange={(v) => this.handleSelected(adSelectedType.head, v)}
      nativeOnClick={($event) => { $event.stopPropagation() }}
      // vOn:click_native={($event) => { $event.stopPropagation() }}
    />
    {
      this.$store.state.pagination.totalPage > 1
        ? <byted-dropdown
          class='selection-dropdown'
          transfer
          placement='bottom-end'
          offset='87'
        >
          <byted-icon name='angle-down' color='#999' />
          <byted-dropdown-menu slot='list'>
            <byted-dropdown-item
              name='currentPage'
              onClick={() => this.handleSelected(adSelectedType.currentPage)}
            >
              <span class={activeCurrentPage ? 'hight-light-dropdown' : ''}>
                {$bp_t('选择当前页', 'bp.promotion_ad_choose_current_page')}（{this.table.data.length}）
              </span>
            </byted-dropdown-item>
            <byted-dropdown-item
              name='all'
              onClick={() => this.handleSelected(adSelectedType.allPage)}
            >
              <span class={activeAllPage ? 'hight-light-dropdown' : ''}>
                {$bp_t('选择全部', 'bp.promotion_ad_choose_all')}（{this.$store.state.pagination.totalNum}）
              </span>
            </byted-dropdown-item>
          </byted-dropdown-menu>
        </byted-dropdown> : ''
    }

  </div>
}
